import { SalesDashboardQueries } from '@sales-app/graphql/queries/salesDashboard.queries'
import React, { useMemo } from 'react'

import { useUserContext } from '@/context'
import { useGraphql } from '@/hooks/useGraphql'
import LoadingSkeleton from '@/views/Dashboard/LoadingSkeleton'

import { DashboardStats } from './DashboardStats'
import { PotentialBookings } from './PotentialBookings/PotentialBookings'

export const AgentDashboard = () => {
  const { user } = useUserContext()
  const {
    data: agentDashboard,
    isLoading,
    isRefetching,
  } = useGraphql<SalesDashboardQueries.GET_AGENT_DASHBOARD.Response>(
    SalesDashboardQueries.getAgentDashboard.name,
    SalesDashboardQueries.getAgentDashboard(),
    {
      filter: {
        agentId: user?.agent?.id,
      },
    },
    { refetchOnMount: 'always' },
  )

  const { statData } = useMemo(() => {
    return {
      statData: agentDashboard?.agentDashboard?.dashboardStats,
    }
  }, [agentDashboard?.agentDashboard?.dashboardStats])

  const potentialBookings = useMemo(() => {
    return agentDashboard?.agentDashboard?.potentialBookings ? agentDashboard?.agentDashboard?.potentialBookings : []
  }, [agentDashboard?.agentDashboard?.potentialBookings])

  return (
    <div>
      {isLoading || isRefetching ? (
        <LoadingSkeleton />
      ) : (
        <div>
          <DashboardStats statData={statData} />
          <PotentialBookings isLoading={isLoading} potentialBookings={potentialBookings} />
        </div>
      )}
    </div>
  )
}
